import { Navigate } from "react-router-dom";

const SetupPage = () => <Navigate to="/login" replace />;

export default SetupPage;
